/**
 * Travel-mode values stored on Esri / nearby / metrics / AI summary rows.
 *
 * 'drive' and 'walk' are the standard Geographic Explorer options.
 * Boundary-constrained study areas reuse the same column with a suffix
 * (drive_state, drive_county, drive_district, and walk_* equivalents) so they
 * coexist with the unconstrained rings instead of overwriting them.
 */

export const TRAVEL_MODE_LABELS = {
  drive: 'Drive',
  walk: 'Walk',
  drive_state: 'Drive (State)',
  drive_county: 'Drive (County)',
  drive_district: 'Drive (District)',
  walk_state: 'Walk (State)',
  walk_county: 'Walk (County)',
  walk_district: 'Walk (District)',
};

export const TRAVEL_MODE_ORDER = [
  'drive',
  'walk',
  'drive_state',
  'drive_county',
  'drive_district',
  'walk_state',
  'walk_county',
  'walk_district',
];

// Most specific clipped study area wins when a school has one.
export const CLIPPED_TRAVEL_MODE_PREFERENCE = [
  'drive_district',
  'drive_county',
  'drive_state',
  'walk_district',
  'walk_county',
  'walk_state',
];

export const getDefaultTravelMode = (availableTravelModes) => {
  const modes = availableTravelModes || [];
  for (const mode of CLIPPED_TRAVEL_MODE_PREFERENCE) {
    if (modes.includes(mode)) return mode;
  }
  if (modes.includes('drive')) return 'drive';
  if (modes.includes('walk')) return 'walk';
  return modes[0] || 'drive';
};

export const travelModeNoun = (travelMode) => {
  if (travelMode === 'walk') return 'walk';
  if (travelMode === 'drive' || !travelMode) return 'drive';
  if (travelMode.startsWith('walk_')) return `walk (${travelMode.slice(5)})`;
  if (travelMode.startsWith('drive_')) return `drive (${travelMode.slice(6)})`;
  return travelMode.replace(/_/g, ' ');
};

export const getTravelModeOptions = (availableTravelModes) => {
  const modes = availableTravelModes?.length ? availableTravelModes : ['drive'];
  return [...modes]
    .sort((a, b) => {
      const ia = TRAVEL_MODE_ORDER.indexOf(a);
      const ib = TRAVEL_MODE_ORDER.indexOf(b);
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    })
    .map((value) => ({
      value,
      label: TRAVEL_MODE_LABELS[value] || value.replace(/_/g, ' '),
    }));
};
